<template lang="pug">
  .btn-group
    button.btn.btn-default(type="button" @click="openModal('add')" title="タグ" data-testid="btn-func-tag")
      i.fa.bcard-fa-tag-plus
    a.btn.btn-default.dropdown-toggle(href='#', data-toggle='dropdown' data-testid="btn-func-tag-pull-down")
      span.fa.fa-caret-down
    ul.dropdown-menu
      li
        a(href="#", @click="openModal('add')", data-testid="btn-func-add-tag")
          i.fa.bcard-fa-tag-plus.fa-fw
          |
          |
          | タグの追加
        a(href="#", @click="openModal('remove')", data-testid="btn-func-del-tag")
          i.fa.bcard-fa-tag-minus.fa-fw
          |
          |
          | タグの解除

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      //- 未選択
      app-modal(v-model="modalNoItem" type="info")
        template(slot="title") 未選択
        h4 名刺を1件以上選択してください。

      app-modal(v-model="modalTag.add", data-testid="modal-func-add-tag")
        template(slot="title")
          i.fa.bcard-fa-tag-plus
          | &nbsp;タグの追加
        sel-tags(v-model="tags.add", :view_mode="false", :mode="{isDispPv: !isMgmt, canAddPv: !isAgentPage, isEdit: false}")
        .help-block
          p.text-info ※ 追加したいタグを選択してください。
        template(slot="footer" slot-scope="{close}")
          button.btn.btn-primary(type="submit" @click="submit('add')" data-testid="-btn-edit") 追加
          button.btn.btn-default(type="button" @click.prevent="close" data-testid="-btn-cancel") キャンセル

      app-modal(v-model="modalTag.remove", data-testid="modal-func-del-tag")
        template(slot="title")
          i.fa.bcard-fa-tag-minus
          | &nbsp;タグの解除
        sel-tags(v-model="tags.remove", :view_mode="false", :mode="{isDispPv: !isMgmt, canAddPv: false, isEdit: false}")
        .help-block
          p.text-info ※ 解除したいタグを選択してください。
        template(slot="footer" slot-scope="{close}")
          button.btn.btn-primary(type="submit" @click="submit('remove')" data-testid="-btn-edit") 解除
          button.btn.btn-default(type="button" @click.prevent="close" data-testid="-btn-cancel") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import SelTags from '@/components/organisms/SelTags'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const BcardRepository = RepositoryFactory.get('bcard')

export default {
  name: 'FuncTag',
  components: { AppModal, SelTags },
  props: {
    /**
     * checkedIds（ID指定の場合に使う）
     */
    checkedIds: { type: Array, required: false, default () { return [] } },
    /**
     * useSearch（全件選択の場合に使う）
     */
    useSearch: { type: Boolean, required: false, default: false },
    /**
     * conds（全件選択の場合に使う）
     *    - search_target（必須）
     */
    conds: { type: Object, required: false, default () { return {} } }
  },
  data () {
    return {
      modalNoItem: false,
      modalTag: {
        add: false,
        remove: false
      },
      tags: {
        add: [],
        remove: []
      }
    }
  },
  methods: {
    /**
     * @param method 'add' 'remove'
     */
    openModal (method) {
      // 全件検索なのにsearch_targetがない場合、あるいは
      if ((this.useSearch && !this.conds.search_target) ||
        // ID指定なのにIDが未選択の場合
        (!this.useSearch && !this.checkedIds.length)) {
        // 未選択エラー
        this.modalNoItem = true
        return
      }

      // 選択済みデータをリセットしてモーダルを開く
      this.tags[method] = []
      this.modalTag[method] = true
    },
    /**
     * タグの一括追加、または解除処理
     * @param method 'add' 'remove'
     */
    submit (method) {
      const tagIds = this.tags[method].map(tag => tag.id)

      // タグを未選択の場合、処理を実行しない
      if (!tagIds.length) {
        this.showToast('タグを1つ以上選択してください。', { type: 'danger' })
        return
      }

      const vm = this

      const successMessage = {
        add: 'タグ情報を追加しました。',
        remove: 'タグ情報を解除しました。'
      }

      const errorMessage = {
        add: 'タグ情報を追加できませんでした。',
        remove: 'タグ情報を解除できませんでした。'
      }

      BcardRepository.buldChangeTags(
        !this.useSearch ? this.checkedIds : null,
        this.useSearch ? this.conds : null,
        tagIds,
        method,
        this.isMgmt
      )
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.showToast(successMessage[method], { type: 'success' })
            vm.$store.dispatch('reloadBcardList')
            vm.modalTag[method] = false
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || errorMessage[method]
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncTag.vue